export function formatUrl(url?: string): string | undefined {
    if (!url) return undefined

    try {
        const parsed = new URL(url)
        if (parsed.hostname === 'localhost' || parsed.hostname === '127.0.0.1') {
            return url
        }

        if (parsed.protocol === 'http:') {
            parsed.protocol = 'https:'
            return parsed.toString()
        }

        return url
    } catch {
        return url
    }
}
